import { STATE_NAME } from "./account.constants";

export const getActiveAccountFormPanel = state =>
  state[STATE_NAME].activeAccountFormPanel;
